import { FC } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { ICustomPageSection } from '../../models';
import { ExternalLink } from '../../components/link/ExternalLink';

interface IMobileAppSection {
  section: ICustomPageSection;
}

export const MobileAppSection: FC<IMobileAppSection> = ({ section }) => {
  const classes = useStyles();
  return (
    <Grid container justifyContent="space-around" spacing={2} alignItems="center" sx={{ marginTop: 0 }}>
      {section?.sections?.map((sec, index) => {
        return (
          <Grid item xs={12} md={6} key={`${index}`}>
            <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center">
              <Typography component="h5" className={classes.heading}>
                {sec.text}
              </Typography>
              <img className={classes.phoneImg} src={sec.imageUrl} alt="" />
              <Box display="flex" alignItems="center" justifyContent="space-between">
                {sec?.sections?.[0]?.linkUrl && (
                  <ExternalLink target="_blank" to={sec.sections[0].linkUrl}>
                    <img alt="Download on the App Store" src="https://static.stonemartinbuilders.com/stonemartin/images/apple-download.png?v=8482dea" />
                  </ExternalLink>
                )}
                {sec?.sections?.[1]?.linkUrl && (
                  <ExternalLink target="_blank" to={sec.sections[1].linkUrl}>
                    <img alt="Get it on Google Play" src="https://static.stonemartinbuilders.com/stonemartin/images/android-download.png?v=38a70f4" />
                  </ExternalLink>
                )}
              </Box>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

const useStyles = makeStyles<Theme>(theme => ({
  heading: {
    textAlign: 'center',
    fontWeight: 800,
    fontSize: '24px',
    marginBottom: '0rem'
  },
  phoneImg: {
    maxWidth: '100%'
  }
}));
